import { render, staticRenderFns } from "./all-news.vue?vue&type=template&id=4defacb4&"
import script from "./all-news.vue?vue&type=script&lang=js&"
export * from "./all-news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports